const works = (images) => {
	const img = document.querySelectorAll(images);


	function eventClickNewElem(before, after, i) {
		before.addEventListener('click', () => {
			const shadowWrapper = document.createElement('div')
			const zoomImg = document.createElement('img');
			const srcImg = i.firstChild.firstChild;

			document.querySelector('#background').appendChild(shadowWrapper);
			shadowWrapper.style.cssText = `
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 100%;
				background-color: rgba(0, 0, 0, .7);
				position: absolute;	
				top: 0px;
				z-index: 100;	
			`;
			shadowWrapper.classList.add('animate__animated', 'animate__fadeIn');

			shadowWrapper.appendChild(zoomImg);
			zoomImg.classList.add('animate__animated', 'animate__fadeIn');
			zoomImg.setAttribute("src", srcImg.getAttribute('src'));
			
			if (window.matchMedia("max-width: 768px)")) {
				zoomImg.style.cssText = `
				max-width: 100%;
				max-height: 80%;
			`;
			} else {
				zoomImg.style.cssText = `
				width: 70vw;
				height: 90vh;
			`;
			}
			shadowWrapper.addEventListener('click', () => {
				shadowWrapper.remove();
				zoomImg.remove();
			});
		});

		after.addEventListener('click', () => {
			const urlSite = i.firstChild;
			if (urlSite.getAttribute('href') == "#") {
				const siteModalWrapper = document.createElement('div');
				const siteModal = document.querySelector('.works__modal');
				
				document.querySelector('.container').insertBefore(siteModalWrapper, siteModal);
				siteModalWrapper.style.cssText = `
					display: flex;
					justify-content: center;
					align-items: center;
					width: 100%;
					height: 100vh;
					background-color: rgba(0, 0, 0, .7);
					position: absolute;
					top: 0px;
					right: 0px;
					z-index: 1;	
					`;
				siteModal.style.display = 'flex';
				siteModalWrapper.classList.add('animate__animated', 'animate__fadeIn');
				siteModal.classList.add('animate__animated', 'animate__fadeIn');


				siteModalWrapper.addEventListener('click', () => {
					siteModalWrapper.remove();
					siteModal.style.display = 'none'
					siteModal.classList.remove('animate__fadeIn');
				});
			} else {
				urlSite.click();
			}
		});

	}

	function showNewElements(selector) {
		selector.addEventListener('mouseover', () => {
			selector.style.opacity = '1';
		})
		selector.addEventListener('mouseout', () => {
			selector.style.opacity = '0';
		})
	}

	function createNewElemets() {
		img.forEach(i => {
			const before = document.createElement('div');
			before.classList.add('works__img_before')

			const after = document.createElement('div');
			after.classList.add('works__img_after')

			i.appendChild(before);
			i.appendChild(after);

			showNewElements(before);
			showNewElements(after);

			eventClickNewElem(before, after, i);

		})
	}

	createNewElemets()
}

export default works;